<template>
  <div>
    <card
      :headerClasses="headerColor"
      class="no-border-card"
      body-classes="px-0 pb-1"
      footer-classes="pb-2"
    >
      <b-row align-v="center" slot="header">
        <b-col cols="8">
          <h3 class="mb-0 text-white">{{ title }}</h3>
        </b-col>

        <b-col cols="4" class="text-right">
          <b-button
            @click="openOutputTransactionModal()"
            variant="primary"
            style="font-size: large"
            size="sm"
          >
            <i class="no no-plus text-white"></i>
          </b-button>

          <!-- <b-button @click="downloadAsCSV" :disabled="queriedData.length == 0" variant="primary" size="sm" icon>
            <i class="ni ni-cloud-download-95 text-white" title="baixar despesas em CSV (excel)"></i>
          </b-button> -->

          <b-dropdown
            menu
            on
            right
            no-caret
            id="dropdown-1"
            variant="boton"
            style="padding: 0"
          >
            <template v-slot:button-content>
              <svg
                width="5"
                height="19"
                viewBox="0 0 5 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="2.19231" cy="2.19231" r="2.19231" fill="#FFF" />
                <circle cx="2.19231" cy="9.49992" r="2.19231" fill="#FFF" />
                <circle cx="2.19231" cy="16.8078" r="2.19231" fill="#FFF" />
              </svg>
            </template>

            <b-dropdown-item
              @click="downloadAsCSV(true)"
              active
              :loading="queriedData.length > 0"
              style="border-top: 1px solid danger"
              type="default"
            >
              <i
                class="ni ni-cloud-download-95 text-white"
                title="Baixar despesas em .CSV (excel)"
              ></i>
              Relatório Simplificado
            </b-dropdown-item>

            <b-dropdown-item
              @click="downloadAsCSVFiscal(true)"
              active
              :loading="queriedData.length > 0"
              style="border-top: 1px solid danger"
              type="default"
            >
              <i
                class="ni ni-cloud-download-95 text-white"
                title="baixar Relatório Fiscal"
              ></i>
              Relatório Fiscal
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col cols="3">
          <el-select
            class="select-primary pagination-select"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              class="select-primary"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </b-col>
        <b-col cols="9">
          <div
            class="d-flex align-items-center w-100"
            style="
              padding: 7px;
              border: 0.5px solid rgb(218, 218, 218);
              border-radius: 5px;
              background-color: white;
            "
          >
            <input
              class="search-input w-100"
              v-model="searchQuery"
              placeholder="filtrar"
            />
            <button
              v-if="searchQuery"
              type="button"
              class="search-field-clear"
              title="Limpar busca"
              @click="searchQuery = ''"
            >
              <i class="fas fa-times"></i>
            </button>
            <i v-else class="fas fa-search text-muted"></i>
          </div>
        </b-col>
      </b-row>
      <el-table
        :data="queriedData"
        :row-key="(row) => row.id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
        :expand-row-keys="expandRowKeys"
        @expand-change="handleExpandChange"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="expand-content">
              <b-table
                :items="props.row.xfields ? [props.row.xfields] : []"
                :fields="expandTableColumns"
                small
                stacked
              >
                <template #cell(date)="data">
                  {{
                    data.item && data.item.payment && data.item.payment.date
                      ? new Date(
                          data.item.payment.date + ' 12:00:00'
                        ).toLocaleDateString('pt-BR')
                      : '--'
                  }}
                </template>

                <template #cell(value)="data">
                  {{
                    data.item &&
                    data.item.payment &&
                    data.item.payment.value != null &&
                    data.item.payment.value !== '--'
                      ? 'R$ ' +
                        Number(data.item.payment.value)
                          .toFixed(2)
                          .toLocaleString('pt-BR')
                          .replace('.', ',')
                      : '--'
                  }}
                </template>
              </b-table>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          v-bind="column"
        >
          <template #default="scope">
            <div
              @click="handleEdit(scope.$index, scope.row)"
              class="table-cell-clickable"
            >
              {{
                column.formatter
                  ? column.formatter(
                      scope.row,
                      column,
                      scope.row[column.prop],
                      scope.$index
                    )
                  : scope.row[column.prop]
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div
        slot="footer"
        class="col-12 pa-0 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div>
          <h5>
            Total pago:
            <span method="" class="font-weight-light">{{
              totalPago.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
            }}</span>
          </h5>
          <h5>
            Total previsto:
            <span class="font-weight-light">{{
              totalPrevisto.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
            }}</span>
          </h5>
          <h5>
            A pagar:
            <span class="font-weight-light">{{
              totalDifference.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
            }}</span>
          </h5>
        </div>
      </div>

      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            Mostrando {{ from + 1 }} a {{ to }} de {{ total }} entradas

            <span v-if="selectedRows.length">
              &nbsp; &nbsp; {{ selectedRows.length }} linhas selecionadas
            </span>
          </p>
        </div>

        <base-pagination
          class="pagination-no-border"
          :current="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
          @change="paginationChanged($event)"
        >
        </base-pagination>
      </div>
    </card>

    <output-transaction-modal
      v-if="isOutputTransactionModalOpen"
      :isOutputTransactionModalOpen="isOutputTransactionModalOpen"
      @closeOutputTransactionModal="closeOutputTransactionModal"
    ></output-transaction-modal>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Form, FormItem } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import OutputTransactionModal from './OutputTransactionModal.vue'
import { BasePagination } from '@/components'
import usePaginateTable from '../../Composables/usePaginateTable'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'FinanceiroOutputTable',

  setup(props, context) {
    const paginateTable = usePaginateTable(context)

    const total = paginateTable.total
    const from = paginateTable.from
    const to = paginateTable.to
    const queriedData = paginateTable.queriedData
    const pagination = paginateTable.getPagination()
    const billItems = paginateTable.getBillsItems()
    const searchQuery = paginateTable.searchQuery

    function formatDataLocaleString(oldData) {
      return paginateTable.formatDataLocaleString(oldData)
    }
    function sortChange(data) {
      return paginateTable.sortChange(data)
    }
    function createFuseSearch(keys) {
      return paginateTable.createFuseSearch(keys)
    }
    function setBillItems(items) {
      return paginateTable.setBillsItems(items)
    }

    return {
      total,
      from,
      to,
      queriedData,
      pagination,
      billItems,
      searchQuery,
      formatDataLocaleString,
      sortChange,
      createFuseSearch,
      setBillItems,
    }
  },

  components: {
    BasePagination,
    RouteBreadCrumb,
    OutputTransactionModal,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  props: {
    title: {
      type: String,
    },

    headerColor: {
      type: String,
    },

    startDate: {
      type: String,
    },

    endDate: {
      type: String,
    },
  },

  computed: {
    ...mapGetters('financeiro', {
      outputTransactions: 'getOutputTransactionsList',
    }),

    ...mapGetters('auth', {
      user: 'user',
    }),

    totalPago() {
      var totalPago = 0

      const valorRecebido = (this.outputTransactions || []).map((element) => {
        if (!element) return
        if (element.d === element.p || element.hasOwnProperty('p')) {
          return Number(element.v)
        }
      })

      if (!valorRecebido.every((value) => isNaN(value))) {
        let sumPago = valorRecebido.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)

        totalPago = sumPago
      }

      return totalPago
    },

    totalPrevisto() {
      var totalPrevisto = 0
      const values = (this.outputTransactions || []).map((item) =>
        item ? Number(item.v) : NaN
      )

      if (!values.every((value) => isNaN(value))) {
        let sum = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)

        totalPrevisto = sum
      }

      return totalPrevisto
    },

    totalDifference() {
      return this.totalPrevisto - this.totalPago
    },
  },

  data() {
    return {
      expandRowKeys: [],
      isOutputTransactionModalOpen: false,
      selectedRows: [],
      tableColumns: [
        {
          prop: 'p',
          label: 'Pago em',
          minWidth: 160,
          formatter: (row, col, cell, index) => this.formatterData(row),
          sortable: true,
        },
        { prop: 't', label: 'Descrição', minWidth: 220, sortable: true },
        {
          prop: 'v',
          label: 'Valor',
          validator: function (value) {
            return ['success', 'warning', 'danger'].indexOf(value) !== -1
          },
          minWidth: 135,
          formatter: (row, col, cell, index) => this.formatterMoeda(row),
          sortable: true,
        },
        {
          prop: 'd',
          label: 'Previsão',
          minWidth: 100,
          formatter: (row, col, cell, index) => this.formatterDataPrevisao(row),
          sortable: true,
        },
      ],
      expandTableColumns: [
        {
          key: 'general.label',
          label: 'Rótulo',
          minWidth: 135,
          sortable: false,
        },
        {
          key: 'general.user.name',
          label: 'Usuário',
          minWidth: 135,
          sortable: false,
        },
        {
          key: 'date',
          label: 'Data do pagamento',
          minWidth: 160,
          sortable: false,
        },
        { key: 'value', label: 'Valor', minWidth: 160, sortable: false },
        {
          key: 'general.observation',
          label: 'Obs.',
          minWidth: 160,
          sortable: false,
        },
      ],
    }
  },

  watch: {
    outputTransactions(newValue, oldValue) {
      if (newValue) {
        this.recreateSearchableTable()
      }
    },
  },

  methods: {
    ...mapActions('financeiro', [
      'financeiroStoreCommit',
      'fetchTransactionById',
    ]),

    //TUDO: tornar esse metodo global! esse é o mais recente utilizando encodeURIComponent()

    async downloadAsCSV(reladTransactions) {
      if (reladTransactions === true) {
        this.searchQueryValue = String(this.searchQuery)
        this.searchQuery = ''
        setTimeout(() => {
          this.$emit('loadTransactions')
          this.downloadAsCSV()
        }, 0)
        return
      }
      let currentPerpage = this.pagination.perPage
      let currentPage = this.pagination.currentPage
      let maxPerpage = JSON.parse(
        JSON.stringify(this.pagination.perPageOptions)
      ).pop()
      this.perPageChange(maxPerpage)
      const vm = this

      var mat = this.queriedData.map(function (payment) {
        let transactionData = {}
        try {
          transactionData =
            typeof payment.xfields === 'string'
              ? JSON.parse(payment.xfields)
              : payment.xfields
        } catch (error) {
          console.log('erro ao gerar relatório', error)
          alert('erro ao gerar relatório')
          return
        }

        let cats = payment.cat
        cats = payment.cat.split(': ') || []
        let mainCat = cats[0]
        cats = cats.slice(1)
        let subcats = cats.join(',')
        return [
          //id da transação
          '' + payment.id,
          //paid, quando pago. undefined para pendentes
          payment.p ? payment.p : '"--"',
          //third, descrição (rótulo) da saída
          // payment.t,
          `"${payment.t.replace('#', '')}"`,
          //value
          `"${(payment.v * 1).toFixed(2).replace('.', ',')}"`,
          //data previsão
          payment.d,
          // 'forma de pagamento'
          transactionData.payment.payment_method.name
            ? transactionData.payment.payment_method.name
            : '--',
          //id do agent/client
          `"${
            payment.xfields && payment.xfields.payment
              ? payment.xfields.payment['supplier_document']
              : payment.aid
              ? `"${payment.aid}"`
              : '--'
          }"`,
          //Nome do agent/cliente
          `"${
            payment.xfields && payment.xfields.payment
              ? payment.xfields.payment['supplier_name']
              : payment.cid
              ? `"${payment.cid}"`
              : '--'
          }"`,
          //Categoria
          mainCat || '"--"',
          //Subcategoria
          `${subcats != '' ? `"${subcats}"` : '"--"'}`,
        ]
      })

      mat.unshift([
        'ID',
        'Pago',
        'Descrição',
        '"Valor (R$ 0,00)"',
        'Previsão',
        'Forma de pagamento',
        'Documento do Cliente',
        'Nome do Cliente',
        'Categoria',
        'Subategorias',
      ])

      var universalBOM = '\uFEFF'
      let csvContent =
        'data:text/csv;charset=utf-8,' +
        universalBOM +
        mat
          .map((e) => e.join(';'))
          .join('\n')
          .toUpperCase()
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute(
        'download',
        `${this.user.username}_janoo_despesas_financeiras_-_${
          this.startDate
        }_-_${this.endDate}_${new Date().getTime()}.csv`
      )
      document.body.appendChild(link)

      link.click()
      this.perPageChange(currentPerpage)
      this.pagination.currentPage = currentPage
      setTimeout(() => {
        this.searchQuery = this.searchQueryValue
      }, 3000)
    },

    downloadAsCSVFiscal(reladTransactions) {
      if (reladTransactions === true) {
        this.searchQueryValue = String(this.searchQuery)
        this.searchQuery = ''
        setTimeout(() => {
          this.$emit('loadTransactions')
          this.downloadAsCSVFiscal()
        }, 0)
        return
      }

      let currentPerpage = this.pagination.perPage
      let currentPage = this.pagination.currentPage
      let maxPerpage = JSON.parse(
        JSON.stringify(this.pagination.perPageOptions)
      ).pop()
      this.perPageChange(maxPerpage)

      var mat = this.queriedData.map(function (payment) {
        let transactionData = {}

        try {
          transactionData =
            typeof payment.xfields === 'string'
              ? JSON.parse(payment.xfields)
              : payment.xfields
        } catch (error) {
          console.log('Erro ao gerar relatório', error)
          alert('Erro ao gerar relatório')
          return
        }

        return [
          //id da transação
          transactionData.general.date.replaceAll('-', '') +
            '.' +
            transactionData.general.id +
            '.' +
            payment.id,

          //data previsão 'Carimbo de data/hora'
          `"${payment.p}"`,

          // 'Colaborador'
          `"${transactionData.general.user.name}"`,

          // 'Rótulo',
          `"${payment.t.replace('#', '').replace('(parcial)', '').trim()}"`,

          // Valor
          `"${Number(transactionData.payment.value || 0)
            .toFixed(2)
            .replace('.', ',')}"`,

          // 'forma de pagamento'
          transactionData.payment.payment_method.name
            ? transactionData.payment.payment_method.name
            : '--',

          // 'CV'
          `"${transactionData.payment.cv || '--'}"`.trim(),

          // 'AUT'
          `"${transactionData.payment.aut || '--'}"`.trim(),

          // 'ID PIX'
          `"${transactionData.payment.pix_id || '--'}"`.trim(),

          // 'NF'
          `"${transactionData.payment.invoice_number || '--'}"`.trim(),

          // Fornecedor: nome
          `"${transactionData.payment.supplier_name || '--'}"`.trim(),

          // Fornecedor: document
          `"${transactionData.payment.supplier_document || '--'}"`.trim(),

          // 'Valor Total'
          `"${Number(transactionData.payment.value || 0)
            .toFixed(2)
            .replace('.', ',')}"`,
        ]
      })

      mat.unshift([
        'ID',
        'Carimbo de data/hora',
        'Colaborador',
        'Rótulo',
        '"Valor (R$ 0,00)"',
        'Forma de pagamento',
        'CV',
        'AUT',
        'ID PIX',
        'Nota Fiscal',
        'Fornecedor: nome',
        'Fornecedor: documento',
        '"Conta: Valor Total (R$ 0,00)"',
      ])

      var universalBOM = '\uFEFF'
      let csvContent =
        'data:text/csv;charset=utf-8,' +
        universalBOM +
        mat
          .map((e) => e.join(';'))
          .join('\n')
          .toUpperCase()
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute(
        'download',
        `${this.user.username}_janoo_receitas_financeiras_fiscal_-_${
          this.startDate
        }_-_${this.endDate}_${new Date().getTime()}.csv`
      )
      document.body.appendChild(link)
      link.click()
      this.perPageChange(currentPerpage)
      this.pagination.currentPage = currentPage
      setTimeout(() => {
        this.searchQuery = this.searchQueryValue
      }, 3000)
    },

    paginationChanged(page) {
      this.pagination.currentPage = page
    },

    perPageChange(perPage) {
      this.pagination.perPage = perPage
      this.pagination.currentPage = 1
    },

    openOutputTransactionModal() {
      this.isOutputTransactionModalOpen = true
      this.financeiroStoreCommit({
        mutation: 'RESET_CURRENT_OUTPUT_TRANSACTION',
      })
    },

    closeOutputTransactionModal() {
      this.isOutputTransactionModalOpen = false
    },

    async handleEdit(index, row) {
      const transaction_pid = row.pid
      const type = '0'
      this.financeiroStoreCommit({
        mutation: 'RESET_CURRENT_OUTPUT_TRANSACTION',
      })

      await this.fetchTransactionById({
        pid: transaction_pid,
        type: type,
      }).then(() => {
        this.isOutputTransactionModalOpen = true
      })
    },

    formatterMoeda(row) {
      const amount = Number(row && row.v)
      const safeAmount = isFinite(amount) ? amount : 0
      return 'R$ ' + safeAmount.toFixed(2).replace('.', ',')
    },

    formatterData(row) {
      if (!row || row.p === undefined || row.p === null || row.p === '') {
        return '--'
      }
      const date = moment(row.p)
      return date.isValid() ? date.format('DD/MM/YYYY') : '--'
    },

    formatterDataPrevisao(row) {
      if (!row || !row.d) return '--'
      const date = moment(row.d)
      return date.isValid() ? date.format('DD/MM/YYYY') : '--'
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },

    handleExpandChange(row, expandedRows) {
      const id = row.id
      const lastId = this.expandRowKeys[0]
      // disable mutiple row expanded
      this.expandRowKeys = id === lastId ? [] : [id]
    },

    recreateSearchableTable() {
      var transactions = (this.outputTransactions || []).filter(function (
        value
      ) {
        return value != null
      })

      transactions.length > 0
        ? this.setBillItems(transactions)
        : this.setBillItems([])

      this.createFuseSearch([
        'name',
        'cat',
        'cid',
        'd',
        'p',
        't',
        'v',
        'xfields',
        'xfields.general.label',
        'xfields.general.user.name',
        'xfields.general.bill_status',
      ])
    },
  },

  mounted() {
    this.recreateSearchableTable()
  },
}
</script>

<style>
@import url('//unpkg.com/element-ui@2.4.11/lib/theme-chalk/index.css');

.card .table td,
.card .table th,
.card .el-table td,
.card .el-table th {
  padding: 0;
  height: 2.5rem;
}

.card .el-table .el-table__body tr {
  border-left: 2px solid #FFF;
}

.card .el-table .el-table__body tr:hover {
  border-left: 2px solid #12576e;
}

.card .el-table .cell {
  padding: 0;
  height: 100%;
}

.expand-content {
  margin-left: 40px;
}

.table-cell-clickable {
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
</style>
